import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import {
  getAllNotifications,
  getUnreadNotifications,
  readAllNotifications,
  readNotification,
} from "./actions";
import { RootState } from "store/store";
import { Notification } from "./types";

export type NotificationState = {
  recharging: boolean;
  loading: boolean;
  meta: any;
  error: any;
};

export const notificationsAdapter = createEntityAdapter<Notification>();

export const notificationSlice = createSlice({
  initialState: notificationsAdapter.getInitialState<NotificationState>({
    recharging: false,
    loading: false,
    meta: null,
    error: false,
  }),
  name: "notifications",
  reducers: {
    getAllNotificatons: notificationsAdapter.setAll,
    upsertNotification: notificationsAdapter.upsertOne,
  },
  extraReducers: (builder) => {
    // READ ALL NOTIFICATION
    builder.addCase(readAllNotifications.rejected, (state, action) => {
      state.error = action.payload;
    });
    builder.addCase(readAllNotifications.pending, (state) => {
      state.error = undefined;
    });
    builder.addCase(readAllNotifications.fulfilled, (state, action) => {
      state.error = undefined;
      notificationsAdapter.setAll(state, action.payload.data);
    });
    // READ SINGLE NOTIFICATION
    builder.addCase(readNotification.rejected, (state, action) => {
      state.error = action.payload;
    });
    builder.addCase(readNotification.pending, (state) => {
      state.error = undefined;
    });
    builder.addCase(readNotification.fulfilled, (state, action) => {
      state.error = undefined;
      notificationsAdapter.upsertOne(state, action.payload);
    });
    // GET ALL NOTIFICATIONS
    builder.addCase(getAllNotifications.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.recharging = false;
    });
    builder.addCase(getAllNotifications.pending, (state, action) => {
      state.error = false;
      if (action.meta.arg.page && action.meta.arg.page !== 1) {
        state.recharging = true;
      } else {
        state.loading = true;
      }
    });
    builder.addCase(getAllNotifications.fulfilled, (state, action) => {
      state.error = false;
      state.meta = action.payload.meta;
      if (action.meta.arg.page && action.meta.arg.page !== 1) {
        state.recharging = false;
        notificationsAdapter.setMany(state, action.payload.data);
      } else {
        state.loading = false;
        notificationsAdapter.setAll(state, action.payload.data);
      }
    });
    // GET UNREAD NOTIFICATIONS
    builder.addCase(getUnreadNotifications.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.recharging = false;
    });
    builder.addCase(getUnreadNotifications.pending, (state, action) => {
      state.error = false;
      if (action.meta.arg.page && action.meta.arg.page !== 1) {
        state.recharging = true;
      } else {
        state.loading = true;
      }
    });
    builder.addCase(getUnreadNotifications.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
      state.meta = action.payload.meta;
      if (action.meta.arg.page && action.meta.arg.page !== 1) {
        state.recharging = false;
        notificationsAdapter.setMany(state, action.payload.data);
      } else {
        state.loading = false;
        notificationsAdapter.setAll(state, action.payload.data);
      }
    });
  },
});

// selectors

export const { selectAll: selectAllNotifications } =
  notificationsAdapter.getSelectors<RootState>((state) => state.notifications);

// Action creators are generated for each case reducer function
export const { getAllNotificatons } = notificationSlice.actions;
export default notificationSlice.reducer;
